import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Person} from "../../interfaces/person";
import {FormControl} from "@angular/forms";
import {Subscription} from "rxjs";
import {AnalystSearchService} from "./analyst-search.service";

@Component({
    selector: 'analyst-search',
    templateUrl: './analyst-search.component.html',
    styleUrls: ['./analyst-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalystSearchComponent implements OnInit{
  @Input() person?:Person|null = null;
  @Output() personChanged = new EventEmitter<Person|null>();
  formControl= new FormControl<Person|string|null>(null);
  sub: Subscription;
  constructor(public searchService: AnalystSearchService) {
  }

  ngOnInit(){
    this.formControl.setValue(this.person ?? null);
    this.sub = this.formControl.valueChanges.subscribe((value)=>{
      if(typeof value === "string"){
        this.searchService.searchPeople(value);
      }else if( value !== null){
        this.personChanged.emit(value);
      }
    })
  }
  displayFn(person: Person|null) {
    return person?.name ?? '';
  }
  ngOnDestroy(){
    this.sub?.unsubscribe();
  }
}
